import Action from "./action";

export default class Prune extends Action {
    actions;
    timelines;

    constructor(props) {
        super(props);
        this.actions = props.actions || ['default'];
        this.timelines = props.timelines || ['default'];
    }

    async execute(eventLoop) {
        console.log('pruning actions by class name: ', this.actions);
        console.log('pruning timelines by class name: ', this.timelines);
        await eventLoop.pruneActionsByClass(this.actions);
        eventLoop.pruneTimelinesByClass(this.timelines);
    }
}
